<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_5 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<!--<v-row>-->
		<!--	<v-col>-->
		<!--		<template v-if="pratica.id_stato_fase_5 == 9">-->
		<!--			<p>-->
		<!--				Il tuo cliccatore si sta allenando con le nuove regole tecniche e con i nostri sistemi avanzati di allenamento.-->
		<!--			</p>-->
		<!--			<p>-->
		<!--				Compila la sezione "<b>Carica i dati della tua pratica</b>" per permettere al tuo cliccatore di allenarsi al meglio!-->
		<!--			</p>-->
		<!--		</template>-->
		<!--		<template v-else-if="pratica.id_stato_fase_5 == 10">-->
		<!--			<p>-->
		<!--				Il tuo cliccatore sta utilizzando <b>i nostri sistemi avanzati di allenamento personalizzato</b> per essere ancora più veloce ad inserire i tuoi dati.-->
		<!--			</p>-->
		<!--		</template>-->
		<!--		<template v-else-if="pratica.id_stato_fase_5 == 11">-->
		<!--			<p>-->
		<!--				Ti informiamo che il cliccatore affidato alla tua pratica <b>è pronto ad affrontare il Click Day</b>!-->
		<!--			</p>-->
		<!--		</template>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff'],
	data() {
		return {
			pratica: {
				id: null,
				id_stato_fase_5: null,
				ci_sono_aggiornamenti_fase_5: false,
			},
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_5 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_5 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_5',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_5');
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		isLoading() {
			return this.isSettingPratica;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
	
	}
	
}
</script>

<style scoped>

</style>